import React from "react";
import { Link } from "gatsby";
import Layout from "components/layout";
import SEO from "components/seo";
import Image from "components/image";
import Style from "styles/news_detail.module.scss";
import { newsList } from "../../news_data";

const PATH = "/news/ai-support-service/";
const PRESS_RELEASE_URL = "https://www.value-press.com/pressrelease/375248";

const news = newsList.find((item) => item.path === PATH);

const AiSupportService = () => (
  <Layout>
    <SEO
      title="AI導入をトータルで伴走支援するAI導入支援サービスを提供開始しました"
      path="news/ai-support-service"
    />
    <article className={Style.container}>
      <header className={Style.detailHead}>
        <time className={Style.detailHead__date}>{news.date}</time>
        <h1 className={Style.detailHead__title}>
          AI導入をトータルで伴走支援するAI導入支援サービスを提供開始しました
        </h1>
      </header>

      {news.image ? (
        <div className={Style.detailImage}>
          <Image filename={news.image} alt="AI導入支援サービスの提供開始" />
        </div>
      ) : null}

      <div className={Style.detailBody}>
        <p className={Style.detailBody__lead}>
          株式会社イーゼは、企業のAI導入・活用をトータルで支援するAIサービスの提供を開始しました。
          本サービスは、生成AIやAIエージェント、各種AIプラットフォームの導入計画策定から、AIコンサルティング、社内研修、運用の定着化にいたるまで、企業のフェーズや課題に合わせた最適なソリューションを一気通貫で伴走支援するサービスです。
        </p>
        <p className={Style.detailBody__lead}>
          信頼できるパートナー企業の優れたAIプロダクトや研修を組み合わせることで、「活用方法が分からない」「社内に定着しない」といった企業の課題を全フェーズで解決し、利便性を最優先にしたトータル支援を提供します。
        </p>
        <p className={Style.detailBody__note}>
          プレスリリースの全文は以下からご覧いただけます。
        </p>
      </div>

      <div className={Style.detailLinks}>
        <a
          className={Style.detailLinks__btn}
          href={PRESS_RELEASE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          プレスリリース全文を読む（VALUE PRESS）
        </a>
      </div>

      <div className={Style.detailBack}>
        <Link className={Style.detailBack__link} to="/news/">
          ＜ 新着情報一覧へ戻る
        </Link>
        <Link className={Style.detailBack__link} to="/">
          ＜ TOPへ戻る
        </Link>
      </div>
    </article>
  </Layout>
);

export default AiSupportService;
